import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

interface LargeVideoPageStylesClasses {
  largeVideoPage: string;
  largeVideoSection: string;
  gridItems: string;
  backPrevNextButtons: string;
  backTitle: string;
  backButton: string;
  prevNextButtons: string;
  prevButton: string;
  nextButton: string;
  assetTitle: string;
  assetNotFound: string;
}

const styles = makeStyles<Theme, object, keyof LargeVideoPageStylesClasses>((theme) => ({
  largeVideoPage: {
    backgroundColor: theme.palette.background.default,
    width: '100%',
    height: '100%',
  },
  largeVideoSection: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  gridItems: {
    margin: '0 1rem 1rem 1rem',
    position: 'relative',
  },
  backPrevNextButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '22px 25px 25px 15px',
  },
  backTitle: {
    display: 'flex',
  },
  backButton: {},
  prevNextButtons: {},
  prevButton: {
    border: `1px solid ${theme.palette.text.primary}`,
    borderRadius: '5px',
    padding: '5px',
  },
  nextButton: {
    border: `1px solid ${theme.palette.text.primary}`,
    borderRadius: '5px',
    padding: '5px',
    marginLeft: '8px',
  },
  assetTitle: {
    margin: '20px 0 16px 20px',
    maxWidth: '1000px',
  },
  assetNotFound: {
    color: theme.palette.error.main,
    fontSize: '50px',
  },
}));

export default styles;
